import type { WidgetComponent } from "@viz/presentation";

const Container: WidgetComponent = ({ props, children }) => {
  const direction = (props.direction as "row" | "col" | undefined) ?? "col";
  const gap = (props.gap as number | undefined) ?? 0;
  return (
    <div className={`flex w-full ${direction === "row" ? "flex-row" : "flex-col"}`} style={{ gap }}>
      {children}
    </div>
  );
};

export default Container;
